<template>
  <v-container class="pt-0">
    <v-row>
      <v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          :text="tagDetail.name"
          :color="tagDetail.color"
        />
      </v-col>
    </v-row>

    <v-row class="mx-2" style="display: flex; gap: 10px; margin-top: -30px">
      <v-btn
        elevation="5"
        class="rounded-lg"
        @click="changeType('mission')"
        :style="{
          flex: 1,
          backgroundColor: bgColorSelect('mission'),
          color: colorSelect('mission'),
          textTransform: 'none',
          fontWeight: 500,
          justifyContent: 'center',
        }"
      >
        {{ $t("activity") }}
      </v-btn>

      <v-btn
        elevation="5"
        class="rounded-lg"
        @click="changeType('reward')"
        :style="{
          flex: 1,
          backgroundColor: bgColorSelect('reward'),
          color: colorSelect('reward'),
          textTransform: 'none',
          fontWeight: 500,
          justifyContent: 'center',
        }"
      >
        {{ $t("reward") }}
      </v-btn>
    </v-row>

    <v-row>
      <MyTagMission v-if="type == 'mission'" />
      <MyTagReward v-if="type == 'reward'" />
    </v-row>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import { mapState } from "vuex";
import {
  adjustHslBrightness,
  getFontColorBasedOnBg,
} from "@/config/general-function";
import MyTagMission from "../../../components/tag/MyTagMission.vue";
import MyTagReward from "../../../components/tag/MyTagReward.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
    MyTagMission,
    MyTagReward,
  },
  data: () => ({
    profileData: null,
    tagDetail: {},

    type: "mission",
  }),
  created() {
    this.isAppLoading(true);
    this.getTagById();
    this.isAppLoading(false);
  },
  methods: {
    async getTagById() {
      try {
        const tag_id = this.$route.params.id;
        let response = await Axios.get(`/getTagById/${tag_id}`, {
          params: {
            entity_id: this.customer.id,
            entity_type: "employee",
          },
        });
        const dataResponse = response?.data;
        if (dataResponse.status == "success") {
          const data = dataResponse.data || {};
          this.tagDetail = { ...data };
        }
      } catch (err) {
        console.log("getTagById", err);
      }
    },

    getFontColorBasedOnBg(param, param2) {
      const res = getFontColorBasedOnBg(param, param2);
      return res;
    },
    setBackgoundBox(param) {
      const _color = param;
      const darken = adjustHslBrightness(_color, -20);
      const lighten = adjustHslBrightness(_color, 20);
      let _style = `linear-gradient(120deg, ${darken}, ${_color}, ${lighten}, ${_color}, ${darken})`;
      return _style;
    },

    bgColorSelect(param) {
      let color = "#ffffff";
      if (param == this.type) {
        color = this.tagDetail.color;
      }
      return color;
    },
    colorSelect(param) {
      let color = "#000000";
      if (param == this.type) {
        color = getFontColorBasedOnBg(this.tagDetail.color || "#ffffff", "bw");
      }
      return color;
    },

    changeType(newType) {
      if (this.type === newType) return;
      this.type = newType;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
  filters: {},
};
</script>

<style scoped>
.level-card {
  border-radius: 12px !important;
  color: #333;
  overflow: hidden;
}

.member-name {
  font-size: 16px;
  font-weight: 500;
}

.member-code {
  font-size: 14px;
  font-weight: 500;
}

.level-image {
  border-radius: 12px;
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.level-image-container {
  width: 100%;
  max-width: 120px;
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 12px;
}
</style>

